import { css } from '@emotion/react';
import styled from '@emotion/styled';

const drawerPadding = css`
    padding-right: 3rem;
    padding-left: 3rem;
    margin-left: -3rem;
`;

export const DrawerContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const DrawerHeader = styled.div`
  ${drawerPadding}
`;

export const DrawerBody = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    overflow-x: visible;
    ${drawerPadding};
    padding-bottom: 2rem;
`;

export const DrawerFooter = styled.div`
    border-top: solid 1px #e8eaee;
    display: flex;
    flex-direction: column;
    padding: 1rem 0px;
    ${drawerPadding}
`;
